import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class BankTransactionsService {
  constructor(private http: HttpService) {}

  getBankTransactions() {
    return this.http.get('bank-transactions');
  }

  assignBankTransaction(
    bankTransactionId: number | string,
    body: {
      client_id: number;
      destiny_wallet_id: string;
      currency?: string;
      commission?: number | string;
      provider_service_id?: number | string;
    },
  ) {
    return this.http.post(
      `bank-transactions/${bankTransactionId}/assign`,
      body,
    );
  }
}
